import {useLocalApi} from '~/composables/core/http.js';
import {LayoutModalAppUpdate} from '#components';

export default defineNuxtPlugin(() => {
  usePricingStore().getPromotions();

  /* the below code compares a server version with a client's cached version, and recommends a refresh if they are different */
  let intervalId;
  const {appVersion: localVersion, versionPollInterval} = useRuntimeConfig().public;

  async function checkVersion() {
    const {v: apiVersion} =  await useLocalApi().fetch('/version');

    if (localVersion !== apiVersion && !useFModals().areModalsOpen.value) {
      useFModal({
        id: 'app-update',
        size: 'md',
        clickToClose: false,
        showClose: false,
        escToClose: false,
        component: LayoutModalAppUpdate,
        onOpen: () => clearInterval(intervalId),
        onClose: () => intervalId = setInterval(checkVersion, versionPollInterval)
      }).open();
    }
  }

  intervalId = setInterval(checkVersion, versionPollInterval);
});
